@if (!isSigninOrRegister) {
<header id="header" class="header align-items-center sticky-top">
  <div
    class="position-relative d-flex align-items-center top-head justify-content-between"
  >
    <a href="/" class="logo d-flex align-items-center">
      <img src="assets/images/empower-logo.svg" />
    </a>
    <div class="leaders-top">
      <img src="assets/images/cbn.png" width="60" />
      <img src="assets/images/pawan.png" width="60" />
      <img src="assets/images/lokesh.png" width="60" />
    </div>
    <div class="header-social-links gap-3 d-flex">
      <a href="#"><img src="assets/images/facebook.svg" /></a>
      <a href="#"><img src="assets/images/insta.svg" /></a>
      <a href="#"><img src="assets/images/x.svg" /></a>
      <a href="#"><img src="assets/images/youtube.svg" /></a>
    </div>
  </div>
  <div class="f-menu">
    <p-menubar [model]="items" />
    @if (isLoggedIn()) {

    <button class="logout-button" (click)="logout()"><i class="fa-light fa-right-to-bracket"></i> Logout</button>
    } @else {
    <div class="signin-signup" window.location.href="/signin">
      <a href="/signin">Login</a>
    </div>
    }

  </div>
</header>
}

<div *ngIf="isLoading()" class="overlay">
  <div class="card flex justify-content-center">
    <p-progressSpinner
      styleClass="w-4rem h-4rem"
      strokeWidth="8"
      fill="var(--surface-ground)"
      animationDuration=".5s"
    />
  </div>
</div>

<router-outlet></router-outlet>
